import { render, staticRenderFns } from "./IncidentSingle.vue?vue&type=template&id=4a92c6a8&"
import script from "./IncidentSingle.vue?vue&type=script&lang=js&"
export * from "./IncidentSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports